import React from 'react';
import { Github, Linkedin, Mail, ShieldCheck, Search, FileText, BookOpen } from 'lucide-react';
import { Button } from './ui/Button';
export function PortfolioHeader() {
  return <header className="relative min-h-[600px] flex items-center justify-center overflow-hidden" data-id="element-67">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/wJjJxTEnYSmgnWKEYVMLnG/MBplus-login-BG.png)'
    }} data-id="element-68">
        <div className="absolute inset-0 bg-background/90 backdrop-blur-[2px]" data-id="element-69"></div>
      </div>

      <div className="container relative z-10 mx-auto px-4 text-center max-w-4xl pt-20 pb-16" data-id="element-70">
        {/* Profile Image */}
        <div className="relative mb-8 inline-block" data-id="element-71">
          <div className="w-40 h-40 md:w-48 md:h-48 rounded-full overflow-hidden border-4 border-primary/20 shadow-2xl mx-auto" data-id="element-72">
            <img src="https://cdn.magicpatterns.com/uploads/fM9bnbxF7swoYgkw7hwttE/IMG-20191121-WA0009.jpg" alt="Aditya Khurana" className="w-full h-full object-cover" data-id="element-73" />
          </div>
          <div className="absolute -bottom-2 -right-2 bg-background p-2 rounded-full shadow-lg border border-border" data-id="element-74">
            <ShieldCheck className="w-8 h-8 text-primary" data-id="element-75" />
          </div>
        </div>

        <h1 className="text-5xl md:text-6xl font-bold tracking-tight mb-4 bg-clip-text text-transparent bg-gradient-to-r from-primary to-primary/60" data-id="element-76">
          Aditya Khurana
        </h1>

        <p className="text-2xl md:text-3xl text-foreground/80 mb-6 font-light tracking-wide" data-id="element-77">
          Security Engineer & Product Strategist
        </p>

        <p className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-78">
          Bridging the gap between technical security operations and strategic
          product development. Specializing in OSINT, compliance frameworks, and
          secure product lifecycle management.
        </p>

        {/* Featured Project */}
        <div className="mb-8" data-id="element-79">
          <Button className="gap-2 h-14 px-10 text-lg shadow-xl hover:shadow-primary/30 transition-all bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70" onClick={() => window.open('https://osint-app-demo.vercel.app/', '_blank')} data-id="element-80">
            <Search className="w-5 h-5" data-id="element-81" />
            View My OSINT App
          </Button>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-1000" data-id="element-82">
          <Button className="gap-2 h-12 px-8 text-lg shadow-lg hover:shadow-primary/25 transition-all" onClick={() => window.location.href = 'mailto:khuranaa865@gmail.com'} data-id="element-83">
            <Mail className="w-5 h-5" data-id="element-84" />
            Contact Me
          </Button>
          <Button variant="outline" className="gap-2 h-12 px-6 text-lg bg-background/50 backdrop-blur-sm hover:bg-background/80 transition-all" onClick={() => window.open('https://github.com/aditya98', '_blank')} data-id="element-85">
            <Github className="w-5 h-5" data-id="element-86" />
            GitHub
          </Button>
          <Button variant="outline" className="gap-2 h-12 px-6 text-lg bg-background/50 backdrop-blur-sm hover:bg-background/80 transition-all" onClick={() => window.open('https://www.linkedin.com/in/khurana-aditya/', '_blank')} data-id="element-87">
            <Linkedin className="w-5 h-5" data-id="element-88" />
            LinkedIn
          </Button>
          <Button variant="outline" className="gap-2 h-12 px-6 text-lg bg-background/50 backdrop-blur-sm hover:bg-background/80 transition-all" onClick={() => window.open('https://docs.google.com/document/d/1pXSA8LutjiRvXuxV3zS1aGk0c5ULjoI_4XsN1vT92cU/edit?usp=sharing', '_blank')} data-id="element-89">
            <FileText className="w-5 h-5" data-id="element-90" />
            Resume
          </Button>
          <Button variant="outline" className="gap-2 h-12 px-6 text-lg bg-background/50 backdrop-blur-sm hover:bg-background/80 transition-all" onClick={() => window.open('https://medium.com/@aditya-khurana', '_blank')} data-id="element-91">
            <BookOpen className="w-5 h-5" data-id="element-92" />
            Blog
          </Button>
        </div>
      </div>
    </header>;
}